export default __webpack_public_path__ + "static/media/openiitintro.76b5cbfe.jpg";